import { version } from '../../package.json'
import angular from 'angular'

import { useNgVue, useNgVuePlugins, ngVueComponent } from '@jaredmcateer/ngvue3'

import 'angular-route/angular-route'
import 'angular-ui-router/release/angular-ui-router'

import {
  isInternetExplorer,
  hasOwn,
} from '@akerolabs/akero-vue/src/utils/helpers.js'

import routerLinkServiceConstructor from './router/service'
import requestWrapper from './requestWrapper'
import vueProgrammatic from './vueProgrammatic'
import vueStore from './vueStore'
import config from './config'

import * as coreComponents from '@akerolabs/akero-vue/src/components/index'
import * as components from '../index'
import * as intercom from '../services/intercom.io'
import appConfig from '../config/index'
import { LocalisationFactory } from '@akerolabs/akero-vue/src/services/localisation'

import {
  appFormTemplatesFactory,
  appSpecificOptionsFactory,
  appAutoresponseTemplatesFactory,
} from '../services/apps'

import '../scss/styles.scss'

/**
 * @param {String} name
 * @returns {String}
 * @description Returns the angular version of the component name
 */
function directiveName(name) {
  return name.charAt(0).toLowerCase() + name.slice(1)
}

/**
 * @param {Object} module
 * @param {Object} components
 * @description Creates angular directives out of the given object
 * of vue directives.
 */
function createAngularDirectives(components) {
  for (const [key, value] of Object.entries(components)) {
    if (key !== 'default' && hasOwn(components, key)) {
      module.directive(...ngVueComponent(directiveName(value.name), value))
    }
  }
}

/**
 * @returns {String} - the angular module name
 * @description Sets up the config as constants in the angular framework
 */
function useNgConstants() {
  const lists = angular.module('Lists', [])
  for (const [key, value] of Object.entries(appConfig)) {
    /* istanbul ignore else */
    if (key !== 'default' && hasOwn(appConfig, key)) {
      lists.constant(key, value)
    }
  }
  return lists.name
}

const module = angular.module('@akero/vue', [
  useNgVue(),
  useNgVuePlugins(),
  useNgConstants(),
  'ngRoute',
  'ui.router',
])

createAngularDirectives(coreComponents)
createAngularDirectives(components)

module.service('$vueStore', vueStore())
module.service('$vueProgrammatic', vueProgrammatic())
module.service('$routerLink', routerLinkServiceConstructor())
module.service('$vueRequest', requestWrapper)
module.service('Localisation', LocalisationFactory)
module.factory('appSpecificOptions', appSpecificOptionsFactory)
module.factory('appFormTemplates', appFormTemplatesFactory)
module.factory('appAutoresponseTemplates', appAutoresponseTemplatesFactory)

module.service('$isInternetExplorer', function () {
  return isInternetExplorer
})

module.factory('tracker', function () {
  return intercom
})

module.service('$vueVersion', function () {
  return {
    get: () => version,
  }
})

module.config(config)
